module.exports = __webpack_public_path__ + "static/media/44_A.79e9a717.png";